import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-compress-pdf',
    imports: [],
    templateUrl: './blog-compress-pdf.component.html',
    styleUrl: './blog-compress-pdf.component.css'
})
export class BlogCompressPdfComponent {

}
